(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vue-lte-ui", [], factory);
	else if(typeof exports === 'object')
		exports["vue-lte-ui"] = factory();
	else
		root["vue-lte-ui"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition